module.exports = __webpack_public_path__ + "img/sicad.eeea91f7.png";